export const DELETE_SR_MEMBERSHIP_MODAL_NAME =
  'DELETE_SR_MEMBERSHIP_MODAL_NAME';
